export default __webpack_public_path__ + "static/media/x-close.919ff167.svg";